import { SwiperManager, Swiper } from '../vendor/swiper.js';

/**
 * ProductSwiperManager Class
 *
 * This class extends the SwiperManager class and provides custom features
 * for the main product swiper.
 */
class CompareProductsSwiperManager extends SwiperManager {
    /**
     * Constructor
     */
    constructor() {
        super();
    }

    /**
     * Initializes all Swiper instances on the page
     */
    initSwipers() {
        super.initSwipers();

        // Initialize main Swiper
        const mainSwiperElement = document.querySelector('.compare-products.swiper');
        if (mainSwiperElement) {
            const settings = JSON.parse(mainSwiperElement.getAttribute('data-swiper-settings') || '{}');

            const mainSwiper = new Swiper(mainSwiperElement, settings);
            window.swiperInstances.push({ name: mainSwiperElement.id || 'mainSwiper', instance: mainSwiper });
        }
    }
}

// Create an instance of the ProductSwiperManager class
const extendedSwiperManager = new CompareProductsSwiperManager();

// Initialize all Swiper instances
extendedSwiperManager.initSwipers();
